import { createContext, ReactElement, ReactNode, useContext } from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

export { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

export interface IWithSkeletonProps extends SkeletonProps {
    isLoading?: boolean,
    children: ReactElement | null,
}

export const SkeletonContext = createContext(false);

export const WithSkeleton = (
    {
        isLoading,
        children,
        ...skeletonProps
    }: IWithSkeletonProps,
): ReactElement | null => {
    const contextState = useContext(SkeletonContext);
    const currentState = isLoading;

    return (currentState === undefined ? contextState : currentState)
        ? <Skeleton {...skeletonProps} />
        : children;
};

export type TWithSkeletonContextProps = {
    isLoading: boolean,
    children: ReactNode,
}

export const WithSkeletonContext = (
    {
        isLoading,
        children,
    }: TWithSkeletonContextProps,
): JSX.Element => {
    return (
        <SkeletonContext.Provider value={isLoading}>
            {children}
        </SkeletonContext.Provider>
    );
};

export { Skeleton };
